import Box from '@mui/material/Box';
import BackButton from 'src/components/NavButtons/BackButton';
import InfoButton from 'src/components/NavButtons/InfoButton';
import CompleteButton from 'src/components/NavButtons/CompleteButton';

const buttonContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  mt: '2rem',
};

/**
 * NavButtons is a component that displays a back button, a help button, and a complete/submit button.
 *
 * @param {Object} props - The props for the component.
 * @param {boolean} [props.disableBack=false] - If true, the back button will be disabled.
 * @param {string} [props.backText='Back'] - The text to display on the back button.
 * @param {string} [props.completeText='Next'] - The text to display on the complete button.
 *
 * @returns {JSX.Element} - A JSX element representing the NavButtons component.
 */
export default function NavButtons({ disableBack, backText = 'Back', completeText = 'Next' }) {
  return (
    <Box sx={buttonContainerStyle}>
      <BackButton text={backText} disabled={disableBack} />
      <InfoButton />
      <CompleteButton text={completeText} />
    </Box>
  );
}
